import SectionNav from 'components/organisms/SectionNav/SectionNav';
import { docsRoutes } from 'constants/navigation';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styles from './Docs.module.scss';
import { DOC_PAGES } from './Docs.constants';

/**
 * Three columns: topics, content, contents-of-this-page.
 *
 * The grid owns the spacing so neither nav needs to be fixed-position, which
 * is what lets both stick beside the content instead of scrolling away.
 */
const Docs: FC = () => (
  <div className={styles.layout}>
    <SectionNav
      heading="Topics"
      items={DOC_PAGES.map(page => ({
        title: page.title,
        path: docsRoutes.page.url(page.slug),
      }))}
    />
    <Outlet />
  </div>
);

export default Docs;
